import numeral from 'numeral';

// ----------------------------------------------------------------------

// eslint-disable-next-line import/no-named-as-default-member
numeral.register('locale', 'de', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€',
  },
});

// switch between locales
// eslint-disable-next-line import/no-named-as-default-member
numeral.locale('de');
const defaultLocal = 'de-DE';

export function fNumber(number: string | number) {
  return numeral(number).format('0.00');
}

export function fCurrency(number: string | number = 0) {
  const format = numeral(number).format('0,000.00');

  return result(format, '.00');
}

export function fToCurrency(number: string | number = 0, currency = 'EUR') {
  return number.toLocaleString('en-US', {
    style: 'currency',
    currency: currency,
  });
}

export function fPercent(number: string | number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: string | number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: string | number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function fToLocalNumber(number: string | number, locale = defaultLocal) {
  return number.toLocaleString(locale);
}
